import React from "react";
import { useFormikContext } from "formik";

import OfficeWeek from "./OfficeWeek";
import { Select } from "../../components/FormElements";

const OfficeList = (props) => {
  const { values } = useFormikContext();

  if (props.officeLocations) {
    return (
      <React.Fragment>
        <Select
          id="location_id"
          label="Preferred office"
          placeholder="Select Preferred office"
          helperMessage="Please select the office you wish to book."
        >
          {props.officeLocations
            .filter((office) => office.is_enabled)
            .map((office) => (
              <option key={office.location_id} value={office.location_id}>
                {office.location_name}
              </option>
            ))}
        </Select>

        {values.location_id > 0 ? (
          <OfficeWeek
            onSelectedSchoolChange={props.onSelectedSchoolChange}
            onSelectedGenderChange={props.onSelectedGenderChange}
            onDateUpdate={props.onDateUpdate}
            formik={props.formik}
          />
        ) : (
          <> </>
        )}
      </React.Fragment>
    );
  }
  return null;
};

export default OfficeList;
